import { Component, h } from "preact";

import { Icon } from "../../Icon";

export function LikeOutlineIcon(rest) {
  return (
    <Icon {...rest}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9884 7.7665C27.8906 6.648 29.2555 6 30.6919 6C33.3026 6 35.4396 8.102 35.4396 10.7207V18.8339H43.6775C47.8622 18.8339 50.9096 22.8184 49.7526 26.8451L45.7249 40.8424C45.7248 40.8425 45.7249 40.8423 45.7249 40.8424C45.1456 42.8563 43.2966 44.2343 41.2043 44.2343H21.0287C20.7403 44.2343 20.4583 44.1494 20.2177 43.9904L15.3651 40.7819C14.9533 40.5096 14.7056 40.0489 14.7056 39.5552V23.5129C14.7056 23.1591 14.8305 22.8345 15.0387 22.5808L26.9884 7.7665ZM17.6467 24.0321V38.7646L21.4709 41.2932H41.2043C41.9976 41.2932 42.6849 40.7716 42.8983 40.0295L46.9259 26.0329C47.5352 23.9122 45.9338 21.775 43.6775 21.775H33.969C33.1569 21.775 32.4985 21.1166 32.4985 20.3044V10.7207C32.4985 9.74918 31.7013 8.9411 30.6919 8.9411C30.1387 8.9411 29.6176 9.19147 29.2776 9.61303L17.6467 24.0321Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 22.1761C0 21.364 0.658387 20.7056 1.47055 20.7056H10.2938C11.106 20.7056 11.7644 21.364 11.7644 22.1761V42.7638C11.7644 43.576 11.106 44.2343 10.2938 44.2343H1.47055C0.658387 44.2343 0 43.576 0 42.7638V22.1761ZM2.9411 23.6467V41.2932H8.82329V23.6467H2.9411Z"
      />
    </Icon>
  );
}
